import { ShopifyNext } from '@dotdev/next-components'
import React from 'react'
import { GlobalProps } from 'types'


export class DynamicKlaviyoForm extends React.PureComponent<
DynamicKlaviyoForm.Props,
DynamicKlaviyoForm.State
> {
    public static sectionId = 'klaviyo';
    public render(): JSX.Element {
      const {
        klaviyoId,
      } = this.props.section.settings

      return klaviyoId ? (
        <section className={'dynamic-klaviyo-block'}>
          <div className={`klaviyo-form-${klaviyoId}`}></div>
        </section>
      ): null
    }
}

export namespace DynamicKlaviyoForm {
    export interface Options
      extends ShopifyNext.Section<{
        klaviyoId: string;
      }> {}
    export interface Props extends GlobalProps {
      section: DynamicKlaviyoForm.Options;
    }
    export interface State {}
  }